import Produtos from "../components/Produtos";

export default function ProdutosPage() {
  return (
    <div data-testid="page-produtos" className="pt-24 sm:pt-32">
      <Produtos />
    </div>
  );
}
